import { useCallback } from "react";
import { useNavigate } from "react-router";
import { MaxSearchResultCount, universalSearchResultItem, useUniversalSearch } from "Shared/UniversalSearch";
import { useORPCClient } from "Core/oRPC";
import { AppRegistry } from "Apps/AppRegistry";

export const useTenantUniversalSearch = () => {
    const { tenanthealthApi } = useORPCClient();
    const navigate = useNavigate();
    const searchTenant = useCallback(
        async (searchText: string) => {
            if (!searchText) {
                return [];
            }

            const resultList: universalSearchResultItem[] = [];
            const seenTenantIds = new Set<string>();

            try {
                const [idResults, nameResults] = await Promise.all([
                    tenanthealthApi.postGetAllTenantsById({ TenantId: searchText }),
                    tenanthealthApi.postGetAllTenantsByName({ TenantName: searchText })
                ]);

                idResults.forEach((tenant) => {
                    const tenantId = tenant.OMSTenantId ?? "";
                    if (tenantId && !seenTenantIds.has(tenantId)) {
                        seenTenantIds.add(tenantId);
                        resultList.push({
                            id: tenantId,
                            title: tenant.TenantName ?? "Tenant Name Not Found",
                            description: tenantId,
                            onClick: () => {
                                navigate(`/customerhub/${tenantId}/details/overview/TenantDetailsDuration=1day`);
                            },
                            navigationTarget: `/customerhub/${tenantId}/details/overview/TenantDetailsDuration=1day`
                        });
                    }
                });

                nameResults.forEach((tenant) => {
                    const tenantId = tenant.OMSTenantId ?? "";
                    if (tenantId && !seenTenantIds.has(tenantId)) {
                        seenTenantIds.add(tenantId);
                        resultList.push({
                            id: tenantId,
                            title: tenant.TenantName ?? "Tenant Name Not Found",
                            description: tenantId,
                            onClick: () => {
                                navigate(`/customerhub/${tenantId}/details/overview/TenantDetailsDuration=1day`);
                            }
                        });
                    }
                });

                return resultList.slice(0, MaxSearchResultCount);
            } catch (error) {
                return resultList;
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [navigate]
    );

    const { searchWord } = useUniversalSearch("Tenants", "tenant name or ID", searchTenant, false, AppRegistry.CustomerHub.path);
    return { searchWord };
};
